// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"_93444fe79c--wrapper--3Lys1","desktop-card":"_93444fe79c--desktop-card--yD6kJ"};